export const WATERFALL_COLOR_SCALE: Array<[number, string]> = [
  [0.0, 'rgb(255, 255, 255)'],
  [0.00392156862745098, 'rgb(251, 252, 254)'],
  [0.00784313725490196, 'rgb(247, 249, 252)'],
  [0.011764705882352941, 'rgb(243, 246, 251)'],
  [0.01568627450980392, 'rgb(240, 243, 250)'],
  [0.0196078431372549, 'rgb(236, 240, 249)'],
  [0.023529411764705882, 'rgb(232, 237, 247)'],
  [0.027450980392156862, 'rgb(228, 234, 246)'],
  [0.03137254901960784, 'rgb(224, 231, 245)'],
  [0.03529411764705882, 'rgb(220, 228, 243)'],
  [0.0392156862745098, 'rgb(216, 225, 242)'],
  [0.043137254901960784, 'rgb(213, 222, 241)'],
  [0.047058823529411764, 'rgb(209, 219, 239)'],
  [0.050980392156862744, 'rgb(205, 216, 238)'],
  [0.054901960784313725, 'rgb(201, 213, 237)'],
  [0.058823529411764705, 'rgb(197, 210, 236)'],
  [0.06274509803921569, 'rgb(193, 207, 234)'],
  [0.06666666666666667, 'rgb(189, 204, 233)'],
  [0.07058823529411765, 'rgb(186, 201, 232)'],
  [0.07450980392156863, 'rgb(182, 198, 230)'],
  [0.0784313725490196, 'rgb(178, 195, 229)'],
  [0.08235294117647059, 'rgb(174, 192, 228)'],
  [0.08627450980392157, 'rgb(170, 189, 226)'],
  [0.09019607843137255, 'rgb(166, 186, 225)'],
  [0.09411764705882353, 'rgb(162, 183, 224)'],
  [0.09803921568627451, 'rgb(159, 180, 223)'],
  [0.10196078431372549, 'rgb(155, 177, 221)'],
  [0.10588235294117647, 'rgb(151, 174, 220)'],
  [0.10980392156862745, 'rgb(147, 171, 219)'],
  [0.11372549019607843, 'rgb(143, 168, 217)'],
  [0.11764705882352941, 'rgb(139, 165, 216)'],
  [0.12156862745098039, 'rgb(135, 162, 215)'],
  [0.12549019607843137, 'rgb(131, 159, 213)'],
  [0.12941176470588237, 'rgb(128, 156, 212)'],
  [0.13333333333333333, 'rgb(124, 153, 211)'],
  [0.13725490196078433, 'rgb(120, 150, 210)'],
  [0.1411764705882353, 'rgb(116, 147, 208)'],
  [0.1450980392156863, 'rgb(112, 144, 207)'],
  [0.14901960784313725, 'rgb(108, 141, 206)'],
  [0.15294117647058825, 'rgb(104, 138, 204)'],
  [0.1568627450980392, 'rgb(101, 135, 203)'],
  [0.1607843137254902, 'rgb(97, 132, 202)'],
  [0.16470588235294117, 'rgb(93, 129, 200)'],
  [0.16862745098039217, 'rgb(89, 126, 199)'],
  [0.17254901960784313, 'rgb(85, 123, 198)'],
  [0.17647058823529413, 'rgb(81, 120, 197)'],
  [0.1803921568627451, 'rgb(77, 117, 195)'],
  [0.1843137254901961, 'rgb(74, 114, 194)'],
  [0.18823529411764706, 'rgb(70, 111, 193)'],
  [0.19215686274509805, 'rgb(66, 108, 191)'],
  [0.19607843137254902, 'rgb(62, 105, 190)'],
  [0.2, 'rgb(62, 105, 190)'],
  [0.20392156862745098, 'rgb(62, 106, 189)'],
  [0.20784313725490197, 'rgb(62, 106, 187)'],
  [0.21176470588235294, 'rgb(62, 107, 186)'],
  [0.21568627450980393, 'rgb(62, 108, 185)'],
  [0.2196078431372549, 'rgb(62, 108, 184)'],
  [0.2235294117647059, 'rgb(62, 109, 182)'],
  [0.22745098039215686, 'rgb(62, 110, 181)'],
  [0.23137254901960785, 'rgb(62, 111, 180)'],
  [0.23529411764705882, 'rgb(61, 111, 179)'],
  [0.23921568627450981, 'rgb(61, 112, 177)'],
  [0.24313725490196078, 'rgb(61, 113, 176)'],
  [0.24705882352941178, 'rgb(61, 113, 175)'],
  [0.25098039215686274, 'rgb(61, 114, 174)'],
  [0.2549019607843137, 'rgb(61, 115, 172)'],
  [0.25882352941176473, 'rgb(61, 115, 171)'],
  [0.2627450980392157, 'rgb(61, 116, 170)'],
  [0.26666666666666666, 'rgb(61, 117, 169)'],
  [0.27058823529411763, 'rgb(61, 118, 167)'],
  [0.27450980392156865, 'rgb(61, 118, 166)'],
  [0.2784313725490196, 'rgb(61, 119, 165)'],
  [0.2823529411764706, 'rgb(61, 120, 164)'],
  [0.28627450980392155, 'rgb(61, 120, 162)'],
  [0.2901960784313726, 'rgb(61, 121, 161)'],
  [0.29411764705882354, 'rgb(61, 122, 160)'],
  [0.2980392156862745, 'rgb(61, 122, 159)'],
  [0.30196078431372547, 'rgb(60, 123, 157)'],
  [0.3058823529411765, 'rgb(60, 124, 156)'],
  [0.30980392156862746, 'rgb(60, 125, 155)'],
  [0.3137254901960784, 'rgb(60, 125, 153)'],
  [0.3176470588235294, 'rgb(60, 126, 152)'],
  [0.3215686274509804, 'rgb(60, 127, 151)'],
  [0.3254901960784314, 'rgb(60, 127, 150)'],
  [0.32941176470588235, 'rgb(60, 128, 148)'],
  [0.3333333333333333, 'rgb(60, 129, 147)'],
  [0.33725490196078434, 'rgb(60, 129, 146)'],
  [0.3411764705882353, 'rgb(60, 130, 145)'],
  [0.34509803921568627, 'rgb(60, 131, 143)'],
  [0.34901960784313724, 'rgb(60, 132, 142)'],
  [0.35294117647058826, 'rgb(60, 132, 141)'],
  [0.3568627450980392, 'rgb(60, 133, 140)'],
  [0.3607843137254902, 'rgb(60, 134, 138)'],
  [0.36470588235294116, 'rgb(59, 134, 137)'],
  [0.3686274509803922, 'rgb(59, 135, 136)'],
  [0.37254901960784315, 'rgb(59, 136, 135)'],
  [0.3764705882352941, 'rgb(59, 136, 133)'],
  [0.3803921568627451, 'rgb(59, 137, 132)'],
  [0.3843137254901961, 'rgb(59, 138, 131)'],
  [0.38823529411764707, 'rgb(59, 139, 130)'],
  [0.39215686274509803, 'rgb(59, 139, 128)'],
  [0.396078431372549, 'rgb(59, 140, 127)'],
  [0.4, 'rgb(59, 140, 127)'],
  [0.403921568627451, 'rgb(64, 142, 125)'],
  [0.40784313725490196, 'rgb(68, 145, 122)'],
  [0.4117647058823529, 'rgb(73, 147, 120)'],
  [0.41568627450980394, 'rgb(77, 149, 117)'],
  [0.4196078431372549, 'rgb(82, 151, 115)'],
  [0.4235294117647059, 'rgb(86, 154, 112)'],
  [0.42745098039215684, 'rgb(91, 156, 110)'],
  [0.43137254901960786, 'rgb(95, 158, 108)'],
  [0.43529411764705883, 'rgb(100, 161, 105)'],
  [0.4392156862745098, 'rgb(104, 163, 103)'],
  [0.44313725490196076, 'rgb(109, 165, 100)'],
  [0.4470588235294118, 'rgb(114, 167, 98)'],
  [0.45098039215686275, 'rgb(118, 170, 95)'],
  [0.4549019607843137, 'rgb(123, 172, 93)'],
  [0.4588235294117647, 'rgb(127, 174, 91)'],
  [0.4627450980392157, 'rgb(132, 177, 88)'],
  [0.4666666666666667, 'rgb(136, 179, 86)'],
  [0.47058823529411764, 'rgb(141, 181, 83)'],
  [0.4745098039215686, 'rgb(145, 183, 81)'],
  [0.47843137254901963, 'rgb(150, 186, 78)'],
  [0.4823529411764706, 'rgb(154, 188, 76)'],
  [0.48627450980392156, 'rgb(159, 190, 74)'],
  [0.49019607843137253, 'rgb(164, 193, 71)'],
  [0.49411764705882355, 'rgb(168, 195, 69)'],
  [0.4980392156862745, 'rgb(173, 197, 66)'],
  [0.5019607843137255, 'rgb(177, 199, 64)'],
  [0.5058823529411764, 'rgb(182, 202, 61)'],
  [0.5098039215686274, 'rgb(186, 204, 59)'],
  [0.5137254901960784, 'rgb(191, 206, 57)'],
  [0.5176470588235295, 'rgb(195, 209, 54)'],
  [0.5215686274509804, 'rgb(200, 211, 52)'],
  [0.5254901960784314, 'rgb(205, 213, 49)'],
  [0.5294117647058824, 'rgb(209, 215, 47)'],
  [0.5333333333333333, 'rgb(214, 218, 44)'],
  [0.5372549019607843, 'rgb(218, 220, 42)'],
  [0.5411764705882353, 'rgb(223, 222, 40)'],
  [0.5450980392156862, 'rgb(227, 225, 37)'],
  [0.5490196078431373, 'rgb(232, 227, 35)'],
  [0.5529411764705883, 'rgb(236, 229, 32)'],
  [0.5568627450980392, 'rgb(241, 231, 30)'],
  [0.5607843137254902, 'rgb(245, 234, 27)'],
  [0.5647058823529412, 'rgb(250, 236, 25)'],
  [0.5686274509803921, 'rgb(250, 236, 25)'],
  [0.5725490196078431, 'rgb(249, 234, 25)'],
  [0.5764705882352941, 'rgb(248, 232, 26)'],
  [0.5803921568627451, 'rgb(248, 230, 26)'],
  [0.5843137254901961, 'rgb(247, 228, 27)'],
  [0.5882352941176471, 'rgb(246, 226, 27)'],
  [0.592156862745098, 'rgb(245, 224, 27)'],
  [0.596078431372549, 'rgb(245, 222, 28)'],
  [0.6, 'rgb(244, 219, 28)'],
  [0.6039215686274509, 'rgb(243, 217, 29)'],
  [0.6078431372549019, 'rgb(242, 215, 29)'],
  [0.611764705882353, 'rgb(241, 213, 30)'],
  [0.615686274509804, 'rgb(241, 211, 30)'],
  [0.6196078431372549, 'rgb(240, 209, 30)'],
  [0.6235294117647059, 'rgb(239, 207, 31)'],
  [0.6274509803921569, 'rgb(238, 205, 31)'],
  [0.6313725490196078, 'rgb(238, 203, 32)'],
  [0.6352941176470588, 'rgb(237, 201, 32)'],
  [0.6392156862745098, 'rgb(236, 199, 32)'],
  [0.6431372549019608, 'rgb(235, 197, 33)'],
  [0.6470588235294118, 'rgb(234, 195, 33)'],
  [0.6509803921568628, 'rgb(234, 193, 34)'],
  [0.6549019607843137, 'rgb(233, 190, 34)'],
  [0.6588235294117647, 'rgb(232, 188, 35)'],
  [0.6627450980392157, 'rgb(231, 186, 35)'],
  [0.6666666666666666, 'rgb(231, 184, 35)'],
  [0.6705882352941176, 'rgb(230, 182, 36)'],
  [0.6745098039215687, 'rgb(229, 180, 36)'],
  [0.6784313725490196, 'rgb(228, 178, 37)'],
  [0.6823529411764706, 'rgb(227, 176, 37)'],
  [0.6862745098039216, 'rgb(227, 174, 37)'],
  [0.6901960784313725, 'rgb(226, 172, 38)'],
  [0.6941176470588235, 'rgb(225, 170, 38)'],
  [0.6980392156862745, 'rgb(224, 168, 39)'],
  [0.7019607843137254, 'rgb(224, 166, 39)'],
  [0.7058823529411765, 'rgb(223, 164, 39)'],
  [0.7098039215686275, 'rgb(222, 162, 40)'],
  [0.7137254901960784, 'rgb(221, 159, 40)'],
  [0.7176470588235294, 'rgb(221, 157, 41)'],
  [0.7215686274509804, 'rgb(220, 155, 41)'],
  [0.7254901960784313, 'rgb(219, 153, 42)'],
  [0.7294117647058823, 'rgb(218, 151, 42)'],
  [0.7333333333333333, 'rgb(217, 149, 42)'],
  [0.7372549019607844, 'rgb(217, 147, 43)'],
  [0.7411764705882353, 'rgb(216, 145, 43)'],
  [0.7450980392156863, 'rgb(215, 143, 44)'],
  [0.7490196078431373, 'rgb(214, 141, 44)'],
  [0.7529411764705882, 'rgb(214, 139, 44)'],
  [0.7568627450980392, 'rgb(213, 137, 45)'],
  [0.7607843137254902, 'rgb(212, 135, 45)'],
  [0.7647058823529411, 'rgb(211, 133, 46)'],
  [0.7686274509803922, 'rgb(210, 130, 46)'],
  [0.7725490196078432, 'rgb(210, 128, 47)'],
  [0.7764705882352941, 'rgb(209, 126, 47)'],
  [0.7803921568627451, 'rgb(208, 124, 47)'],
  [0.7843137254901961, 'rgb(207, 122, 48)'],
  [0.788235294117647, 'rgb(207, 120, 48)'],
  [0.792156862745098, 'rgb(206, 118, 49)'],
  [0.796078431372549, 'rgb(205, 116, 49)'],
  [0.8, 'rgb(205, 116, 49)'],
  [0.803921568627451, 'rgb(204, 114, 49)'],
  [0.807843137254902, 'rgb(202, 111, 48)'],
  [0.8117647058823529, 'rgb(201, 109, 48)'],
  [0.8156862745098039, 'rgb(200, 107, 47)'],
  [0.8196078431372549, 'rgb(199, 105, 47)'],
  [0.8235294117647058, 'rgb(197, 102, 47)'],
  [0.8274509803921568, 'rgb(196, 100, 46)'],
  [0.8313725490196079, 'rgb(195, 98, 46)'],
  [0.8352941176470589, 'rgb(193, 96, 45)'],
  [0.8392156862745098, 'rgb(192, 93, 45)'],
  [0.8431372549019608, 'rgb(191, 91, 45)'],
  [0.8470588235294118, 'rgb(189, 89, 44)'],
  [0.8509803921568627, 'rgb(188, 87, 44)'],
  [0.8549019607843137, 'rgb(187, 84, 43)'],
  [0.8588235294117647, 'rgb(186, 82, 43)'],
  [0.8627450980392157, 'rgb(184, 80, 43)'],
  [0.8666666666666667, 'rgb(183, 78, 42)'],
  [0.8705882352941177, 'rgb(182, 75, 42)'],
  [0.8745098039215686, 'rgb(180, 73, 41)'],
  [0.8784313725490196, 'rgb(179, 71, 41)'],
  [0.8823529411764706, 'rgb(178, 69, 41)'],
  [0.8862745098039215, 'rgb(176, 66, 40)'],
  [0.8901960784313725, 'rgb(175, 64, 40)'],
  [0.8941176470588236, 'rgb(174, 62, 39)'],
  [0.8980392156862745, 'rgb(173, 60, 39)'],
  [0.9019607843137255, 'rgb(171, 57, 39)'],
  [0.9058823529411765, 'rgb(170, 55, 38)'],
  [0.9098039215686274, 'rgb(169, 53, 38)'],
  [0.9137254901960784, 'rgb(167, 50, 37)'],
  [0.9176470588235294, 'rgb(166, 48, 37)'],
  [0.9215686274509803, 'rgb(165, 46, 37)'],
  [0.9254901960784314, 'rgb(163, 44, 36)'],
  [0.9294117647058824, 'rgb(162, 41, 36)'],
  [0.9333333333333333, 'rgb(161, 39, 35)'],
  [0.9372549019607843, 'rgb(160, 37, 35)'],
  [0.9411764705882353, 'rgb(158, 35, 35)'],
  [0.9450980392156862, 'rgb(157, 32, 34)'],
  [0.9490196078431372, 'rgb(156, 30, 34)'],
  [0.9529411764705882, 'rgb(154, 28, 33)'],
  [0.9568627450980393, 'rgb(153, 26, 33)'],
  [0.9607843137254902, 'rgb(152, 23, 33)'],
  [0.9647058823529412, 'rgb(150, 21, 32)'],
  [0.9686274509803922, 'rgb(149, 19, 32)'],
  [0.9725490196078431, 'rgb(148, 17, 31)'],
  [0.9764705882352941, 'rgb(147, 14, 31)'],
  [0.9803921568627451, 'rgb(145, 12, 31)'],
  [0.984313725490196, 'rgb(144, 10, 30)'],
  [0.9882352941176471, 'rgb(143, 8, 30)'],
  [0.9921568627450981, 'rgb(141, 5, 29)'],
  [0.996078431372549, 'rgb(140, 3, 29)'],
  [1.0, 'rgb(140, 3, 29)'],
]
